<template>
  <!--各学科老师-->
  <div class="g_teacher">
    <!--切换学科-->
    <div class="hdkuang">
      <div class="hdkuang_a">
        <div class="nav_bar nav_none">
          <ul class="swiper-wrapper" id="subject">
            <!-- <li class="swiper-slide active">学前<span></span></li>-->
            <li v-for="(item,index) in courselist" class="swiper-slide" v-bind:class="{active:index==cardIndex}"  @click="cardIndexClick(index)">
              {{item.title}}<span></span></li>

          </ul>
        </div>
      </div>
    </div>
    <!--老师-->

    <div class="zt_tea">
      <!--1-->

      <div v-for="(item,index) in courselist" class="zt_tea1" v-show="cardIndex==index">
        <div v-for="(course) in item.list" class="tea_mes">
          <dl class="dla">
            <dt class="dta">
            <p class="dta_img"><img v-bind:src="course.teachinfo.pic?'http://img.xdf.cn/TeacherIMG/'+course.teachinfo.pic:'http://www.xdf.cn/zhuanti/school/wapm8.27/m1/img/teacherheadimg.jpg'" alt=""/></p>
            <p class="tea_name">{{course.teachinfo.name}}</p>
            </dt>
            <dd class="dda">
              <a v-bind:href="classCodeURl(course.code)">
                <p class="tea_bt">{{course.name}}</p>
                <p class="tea_js"><span>课程介绍：</span>{{course.courseintro}}...</p>
                <p class="tea_rq"><span>适合人群：</span>{{course.studentlevel}}</p>
                <p class="tea_jg"><span>￥{{course.price}}</span>起</p>
              </a>
            </dd>
          </dl>
        </div>

      </div>


    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default{
  props:['courselist'],
  data: function () {
    return {
      cardIndex:0
    }
  },
  methods: {
    classCodeURl(code){
      return `http://m.souke.xdf.cn/course/${this.schoolID}-${code}.html`
    },
    cardIndexClick(index){
      this.cardIndex=index;
    }
  },
  mounted(){
    window.setTimeout(()=>{
      var swiper1= new Swiper('.nav_bar', {
        freeMode : true,
        slidesPerView : 'auto',
      });
  },1000)

  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// components/SubjectList.vue